import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';

import { Observable } from 'rxjs/Observable';
import { of } from 'rxjs/observable/of';
import { catchError, map, tap } from 'rxjs/operators';

import { environment } from '../environments/environment';
import { AndonNotice, OutputAndonNoticeID, AndonNoticeSum } from './andon-notice';

const httpOptions = {
  headers: new HttpHeaders({ 'Content-Type': 'application/json' })
};

@Injectable({
  providedIn: 'root'
})
export class AndonNoticeService {

  errMessage = '';
  // private AndonNoticeUrl = environment.apiUrl + 'AndonNotice';  // Web APIのURL
  // private AndonNoticeUrl = 'api/andonNotice';  // Web APIのURL

  constructor(
    private http: HttpClient ) { }

  /** サーバーからあんどん通知を取得する */
  getAndonNoticeSum ( body ): Observable<AndonNoticeSum[]> {
    // return this.http.get<AndonNoticeSum[]>(this.AndonNoticeSumUrl);
    return this.http.post<AndonNoticeSum[]>(environment.apiUrl + 'AndonNotice/SumList', body,
      { headers: new HttpHeaders().set('Content-Type', 'application/json') } )
    //  { headers: new HttpHeaders().set('Content-Type', 'application/x-www-form-urlencoded; charset=UTF-8') } )
        .pipe(
        // tap(SumList => this.log(`fetched AndonNoticeSum`)),
        catchError(this.handleError('getAndonNoticeSum', []))
    );
  }

  /** サーバーからあんどん通知を取得する */
  getAndonNoticeList ( andonID ): Observable<AndonNotice[]> {
    return this.http.get<AndonNotice[]>(environment.apiUrl + 'AndonNotice/List/' + andonID)
      .pipe(
  //      tap(SumList => this.log(`fetched AndonNotice`)),
        catchError(this.handleError('getAndonNotice', []))
      );
  }

  /** あんどん通知の状態を回復する */
  closeAndonNotice ( body ): void {
    this.http.post(environment.apiUrl + 'AndonNotice/Complete', body, httpOptions ).toPromise();
    console.log('closeAndonNotice() end');
    return;
  }
  /** あんどん通知の状態を削除する */
  deleteAndonNotice ( body ): void {
    this.http.post(environment.apiUrl + 'AndonNotice/Delete', body, httpOptions ).toPromise();
    console.log('deleteAndonNotice() end');
    return;
  }

  /** あんどん通知を作成する */
  createAndonNotice ( body ): void {
    this.http.post(environment.apiUrl + 'AndonNotice', body, httpOptions ).toPromise();
    console.log('createAndonNotice() end');
    return;
  }

  /** サーバーからあんどん通知を取得する */
  getAndonNotice ( andonNoticeID ): Observable<AndonNotice[]> {
    return this.http.get<AndonNotice[]>(environment.apiUrl + 'AndonNotice/' +  andonNoticeID)
      .pipe(
        tap(SumList => this.log(`fetched AndonNotice`)),
        catchError(this.handleError('getAndonNotice', []))
      );
  }

  /**
   * 失敗したHttp操作を処理します。
   * アプリを持続させます。
   * @param operation - 失敗した操作の名前
   * @param result - observableな結果として返す任意の値
   */
  private handleError<T> (operation = 'operation', result?: T) {
    return (error: any): Observable<T> => {

      // TODO: リモート上のロギング基盤にエラーを送信する
      console.error(error); // かわりにconsoleに出力

      // TODO: ユーザーへの開示のためにエラーの変換処理を改善する
      this.log(`${operation} failed: ${error.message}`);

      // 空の結果を返して、アプリを持続可能にする
      return of(result as T);
    };
  }

  /** HeroServiceのメッセージをMessageServiceを使って記録 */
  private log(message: string) {
    console.error('AndonNoticeService: ' + message);
    alert(this.errMessage);
  }
}
